import React from "react";
import { Category } from "./Categories";

interface RibbonProps {
  activeCategory: Category;
  onChange: (category: Category) => void;
}

const Ribbon: React.FC<RibbonProps> = ({ activeCategory, onChange }) => {
  const options: { id: Category; label: string }[] = [
    { id: "patient", label: "Ασθενής" },
    { id: "rv", label: "Ραντεβού" },
    { id: "surgery", label: "Χειρουργείο" },
    { id: "medicine", label: "Φαρμακευτική Αγωγή" },
    { id: "medicineDose", label: "Δόσεις Φαρμάκων" },
    { id: "user", label: "Χρήστες" },
    { id: "implant", label: "Εμφυτεύματα" },
    { id: "allergy", label: "Αλλεργίες" },
    { id: "disease", label: "Ασθένειες" },
    { id: "documentType", label: "Τύπος Εξετάσεων" },
    { id: "historyType", label: "Τύπος Ιστορικού" },
    { id: "doctor", label: "Ιατροί" },
    { id: "specialty", label: "Ιατρικές Ειδικότητες" },
    { id: "rehabCenter", label: "Κέντρα Αποκατάστασης" },
  ];

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-1.5 flex gap-1 overflow-x-auto shadow-sm">
      {options.map((option) => {
        const isActive = activeCategory === option.id;

        return (
          <button
            key={option.id}
            onClick={() => onChange(option.id)}
            className={`px-4 py-2.5 text-sm font-medium rounded-lg transition-all whitespace-nowrap border ${
              isActive
                ? "bg-primary border-primary text-white font-semibold shadow-sm"
                : "bg-transparent border-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900"
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default Ribbon;